// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import GRRound from '../components/GRRound';
import selectGRRoundProps from '../selectors/specifics/selectGRRoundProps';
import { GRRounds } from '../types/round';

const roundId = GRRounds.SHOE;

type GRRound1ContainerProps = {
  className?: string;
  children?: React.ReactNode;
};

const GRRound1Container = (ownProps: GRRound1ContainerProps) => {
  const selectorProps = useMemo(() => ({ roundId }), []);
  const selectedProps = useSelector((state) => selectGRRoundProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GRRound {...enhancedProps} roundId={GRRounds.SHOE} />;
};

export default GRRound1Container;
